// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { OfferStatusState } from "@/types/offerStatus";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { OfferStatus } from "@/models/offerStatus";

const state: OfferStatusState = {
  single: new OfferStatus(),
  pagination: new Pagination(),
};

export const offerStatus: Module<OfferStatusState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
